import { apiClient } from './client';
export const moderationApi = {
    // List flagged conversations
    listFlaggedConversations: async (params) => {
        const response = await apiClient.get('/v1/admin/moderation/conversations', { params });
        return response.data;
    },
    // Get flagged conversation details
    getFlaggedConversation: async (id) => {
        const response = await apiClient.get(`/v1/admin/moderation/conversations/${id}`);
        return response.data;
    },
    // Take moderation action on conversation
    takeConversationAction: async (id, action) => {
        await apiClient.post(`/v1/admin/moderation/conversations/${id}/action`, action);
    },
    // List reports
    listReports: async (params) => {
        const response = await apiClient.get('/v1/admin/moderation/reports', { params });
        return response.data;
    },
    // Get report details
    getReport: async (id) => {
        const response = await apiClient.get(`/v1/admin/moderation/reports/${id}`);
        return response.data;
    },
    // Update report status
    updateReportStatus: async (id, status, notes) => {
        const response = await apiClient.patch(`/v1/admin/moderation/reports/${id}/status`, {
            status,
            notes,
        });
        return response.data;
    },
    // Resolve report
    resolveReport: async (id, resolution) => {
        const response = await apiClient.post(`/v1/admin/moderation/reports/${id}/resolve`, resolution);
        return response.data;
    },
};
